module.exports = __webpack_public_path__ + "media/images/common/3column_product_bg_nny-e5b4646088fae0fb5a94533e2422d43f.png";